module.exports = __webpack_public_path__ + "img/camera.e40f8709.svg";